import { Box, Typography } from "@mui/material";
import { CircleCheck, CircleX } from "lucide-react";
import { useTranslation } from "react-i18next";
import { OutputMessageProps } from "./type";
import { ButtonDigited } from "../../components/Button/Button.variants";

const OutputMessageModal: React.FC<OutputMessageProps> = ({ success, closeModal }) => {
  const { t } = useTranslation();

  return (
    <Box 
      sx={ {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: "1.25rem",
        justifyContent: "center"
      } }
    >
      { success ? <CircleCheck size="3rem"/> : <CircleX size="3rem"/> }
      <Typography id="confirmation-modal-title" variant="h6">
        { success ? t("success") : t("failed") }
      </Typography>
      <ButtonDigited
        typology="primary"
        onClick={ closeModal }
        text={ t("close") }
      ></ButtonDigited>
    </Box>
  );
};

export default OutputMessageModal;
